import {
  EnvironmentProviders,
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { SOFTLINE_CONFIG_LOGIN_LINKS } from '@softapps/allgemein/login';
import { SOFTLINE_CONFIG_SETTINGS } from '@softline/application';
import {
  AuthenticationContextStore,
  PasswordRepository,
  SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT,
} from '@softline/auth';
import { isNullOrEmpty, Store, StoreModule } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { map } from 'rxjs/operators';
import { default as de } from '../i18n/de.json';
import { default as en } from '../i18n/en.json';
import { PASSWORD_SETTINGS_KEY } from './password.tokens';
import { SettingsComponent } from './settings/components/settings.component';
import { SOFTLINE_FEATURE_PASSWORD } from './password.shared';
import { PasswordStore } from './store/password.store';

export const passwordProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'password',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'password',
      language: 'en',
      translations: en,
    });
  }),
  {
    provide: SOFTLINE_CONFIG_LOGIN_LINKS,
    useValue: { name: '#PASSWORD.TITLE', route: ['/forgot-password'] },
    multi: true,
  },
  {
    provide: SOFTLINE_CONFIG_SETTINGS,
    multi: true,
    useFactory: (store: Store) => {
      return {
        key: PASSWORD_SETTINGS_KEY,
        component: SettingsComponent,
        title: '#PASSWORD.SETTINGS.TITLE',
        icon: 'fa-regular fa-key',
        group: 'internal',
        visible: store
          .observe(
            SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT,
            AuthenticationContextStore.getters.data
          )
          .pipe(map((o) => !isNullOrEmpty(o))),
      };
    },
    deps: [Store],
  },
  importProvidersFrom(
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_PASSWORD,
      feature: PasswordStore.feature,
      providers: [
        {
          provide: PasswordRepository,
          useFactory: () => new PasswordRepository(),
        },
      ],
    })
  ),
];
